// @ts-nocheck
import {
  hasApensado,
  isEssentialPlanProcess,
  isEtapaAnalise,
  isParentApensadoProcess,
} from "helpers/process.helper";
import CardAnalise from "./CardAnalise";
import EtapaResumo from "./EtapaResumo";
import SobreTranscricao from "./SobreTranscricao";
import Cabecalho from "./Etapas/Cabecalho";
import Documentacao from "./Etapas/Documentacao";
import Analise, { Obstaculo } from "./Etapas/Analise";
import Apostilamento from "./Etapas/Apostilamento";
import Despacho from "./Etapas/Despacho";
import Portugal, { Exigencia } from "./Etapas/Portugal";
import Conclusao from "./Etapas/Conclusao";
import { useEmissoes } from "./Etapas/useEmissoes";
import { Corpo, Selo, Titulo } from "./Etapas/ui";
import { Container } from "./styles";

// Card de cada pedido em Meus pedidos. Hierarquia igual em todas as etapas
// (canvas de 28/10/2026): quem → selo → título e frase → avisos → dois
// blocos → barra → ação principal → lista do que falta → ajuda.
// O plano Análise tem etapas próprias (CardAnalise), ainda no formato antigo.
export default function ComponentCard({
  data,
  next,
  complete,
  controllerModal,
  modalAnalysis,
  modalFollowUp,
  FMDModal,
  processes,
  onProcessoAtualizado,
}) {
  const process = data || next || complete;
  const etapa = data?.step?.name;
  const emissoes = useEmissoes(etapa === "documentation" || etapa === "incomplete_documentation");

  const apensado = hasApensado(data, next, complete);
  const aguardaApensados = isParentApensadoProcess(data, next, complete);
  const isEssential = isEssentialPlanProcess(data, next, complete);
  const apensadoCompleto = apensado && Number(data?.documents_completed) >= 100;

  let corpo = null;
  if (complete) {
    corpo = <Conclusao process={complete} />;
  } else if (next) {
    corpo = (
      <Corpo>
        <Selo tipo="neutro">AINDA NÃO INICIADO</Selo>
        <Titulo>Este pedido começa depois dos anteriores</Titulo>
        <p className="desc">
          Para dar andamento ao processo de {next?.applicant?.name}, é preciso concluir os pedidos anteriores. Avisamos aqui quando ele começar.
        </p>
      </Corpo>
    );
  } else if (isEtapaAnalise(etapa)) {
    corpo = (
      <>
        <EtapaResumo process={data} />
        <CardAnalise data={data} onProcessoAtualizado={onProcessoAtualizado} controllerModal={controllerModal} FMDModal={FMDModal} />
      </>
    );
  } else if (etapa === "documentation" || etapa === "incomplete_documentation") {
    corpo = (
      <Documentacao
        process={data}
        emissoes={emissoes}
        controllerModal={controllerModal}
        FMDModal={FMDModal}
        apensadoCompleto={apensadoCompleto}
      />
    );
  } else if (etapa === "complete_documentation") {
    corpo = <Analise process={data} />;
  } else if (etapa === "blocked" || etapa === "blocked_post") {
    corpo = <Obstaculo process={data} action={modalAnalysis} />;
  } else if (etapa === "hague" || etapa === "docs_ok" || etapa === "unblocked") {
    corpo = <Apostilamento process={data} isEssential={isEssential} />;
  } else if (etapa === "post") {
    corpo = <Despacho process={data} />;
  } else if (etapa === "requirement") {
    corpo = <Exigencia process={data} action={modalFollowUp} />;
  } else if (etapa === "monitoring" || etapa === "approved" || etapa === "dispatched") {
    corpo = <Portugal process={data} />;
  }

  return (
    <Container key={process?.id}>
      <Cabecalho
        process={process}
        apensado={apensado}
        aguardaApensados={aguardaApensados}
        apensadoCompleto={apensadoCompleto}
      />
      {corpo}
      <SobreTranscricao process={process} processes={processes} />
    </Container>
  );
}
